import Vue from 'vue'
import Room from './components/Room'
import TruckScheduleAdmin from './components/TruckScheduleAdmin.vue'
import SiteSwitch from './components/SiteSwitch.vue'
import VModal from 'vue-js-modal'

var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo);

window.Vue = Vue;

Vue.use(VModal);

var app = new Vue({
    el: '#app',

    components: {
        SiteSwitch,
        TruckScheduleAdmin,
        Room
    }
});

const navToggle = document.getElementById('nav-toggle');
const primaryNav = document.getElementById('primary-nav');

// Navbar Toggle Animations
navToggle.addEventListener('click', toggleNavbar);

function toggleNavbar() {
    this.classList.toggle('masthead__nav-toggle--open');
    if(!this.classList.contains('masthead__nav-toggle--open')) {
        primaryNav.classList.remove('primary-nav--open');
        this.classList.add('masthead__nav-toggle--closing');
        this.removeEventListener('click', toggleNavbar);

        setTimeout(() => {
            this.classList.remove('masthead__nav-toggle--closing');
            this.addEventListener('click', toggleNavbar);
        }, 500);
    } else {
        //open
        primaryNav.classList.add('primary-nav--open');
    }
}


// WEBPACK FOOTER //
// ./source/js/main.js